import {Base} from "@/api/Base"

export class OvertimeApplicationAdd extends Base {
    path = "overtimeApplication/add"
}